import axiosInstance from "api/axios";
import { Depot } from "types/depot.type";

export const depotService = {
  getAll: async (
    page: number = 1,
    limit: number = 10,
    filters: Record<string, any> = {}
  ): Promise<{ data: Depot[]; total: number }> => {
    const params = { page, limit, ...filters };
    const { data } = await axiosInstance.get("/depot", { params });
    return data;
  },
  create: async (form: Partial<Depot>) => {
    return axiosInstance.post("/depot", form);
  },
  update: async (id: number, form: Partial<Depot>) => {
    return axiosInstance.put(`/depot/${id}`, form);
  },
  delete: async (id: number) => {
    return axiosInstance.delete(`/depot/${id}`);
  },
};
